import { Box, Cell, Layout, Text } from '@wix/design-system';
import { useTranslation } from '@wix/fe-essentials-standalone';
import { Location, LocationSmall } from '@wix/wix-ui-icons-common';
import { FC } from 'react';
import { generateLocationLabel } from '../../../utils/locationLabel';
import { useProfileContext } from '../../Contexts/ProfileContext';

type Props = {
  showTitle?: boolean;
  isMobileView?: boolean;
  marginTop?: string;
};

const ProviderLocation: FC<Props> = ({ showTitle, marginTop }) => {
  const { partnerProfile } = useProfileContext();

  const { t } = useTranslation();

  return (
    <>
      {showTitle && (
        <Text weight="bold">{t('profile-page-location-and-language')}</Text>
      )}
      <Box verticalAlign="middle" marginTop={marginTop}>
        <Layout gap="0px" alignItems="center">
          <Cell span={1}>
            <Box paddingRight="3px">
              <LocationSmall />
            </Box>
          </Cell>
          <Cell span={11}>
            <Text
              showTooltip
              ellipsis
              maxLines={1}
              size="small"
              weight="thin"
              dataHook="provider-location"
            >
              {partnerProfile.address &&
                generateLocationLabel(partnerProfile.address)}
            </Text>
          </Cell>
        </Layout>
      </Box>
    </>
  );
};

export default ProviderLocation;
